// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************************************
Colors
***********************************************/
/***** Brand *****/
:root {
  /* Infinity brand colors */
  --color-brand: #e73389;
  --color-brand-dark: #af2769;
  --color-brand-light: #f29dc3;
  --color-brand-picker: #e73389;
  /* Infinity brand colors */
  --color-headerBg: #0a3749;
  --color-headerTxt: #ffffff;
  /* Infinity playback colors */
  --color-brandPlyr: #e73389;
  --color-brand-darkPlyr: #af2769;
  --color-brand-lightPlyr: #f29dc3;
  font-size: 14px;
}

/***** Infinity *****/
/***** Positive *****/
/***** Warning *****/
/***** Negative *****/
/***** Information *****/
/***** Royal *****/
/***** Sun *****/
/***** Slates *****/
/*slate*/
/*stone*/
/*silver*/
/***** Blacks *****/
/*black*/
/***** Grays *****/
/***** Brand greyout set *****/
/***** Brand greyout set *****/
.av-border {
  border: 1px solid #000;
}
.file-error {
  margin-top: 7rem;
}
.file-input.is-invalid .custom-file-label {
  border: 1px solid #f44336;
}
.file-input .custom-file-label {
  text-align: center;
  padding-top: 5rem;
  padding-bottom: 5rem;
  display: flex;
  border: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.2s ease-in-out;
}
.file-input .custom-file-label:hover {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}
.file-input .custom-file-label:after {
  display: none;
}
.file-input .custom-file-label > span {
  width: 100%;
  height: 100%;
}
.file-input .custom-file-label.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-input input[disabled] + label {
  cursor: not-allowed;
}
.uploadPlaceholder {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
